export * from './canIUse';
export * from './envInfo';
export * from './goTo';
export * from './init';
export * from './initSDK';
export * from './locate';
export * from './login';
export * from './omega';
export * from './pay';
export * from './query';
export * from './request/index';
export * from './resapi';
export * from './saveImg';
export * from './share';
export * from './storage';
export * from './subscribe';
export * from './utils';
export * from './webx';
export * from './xenv';
export * from './platform';
export * from './mini';
export * from './launchApp';
export * from './mixins';
export * from './perfTrack';
export * from './version';
